import React from 'react';
import { Grid } from 'semantic-ui-react';

import ImageRow from './ImageRow';

export default ({ imageGroups, rightArrow, leftArrow }) => (
  <Grid className="ic-image-grid" stackable>
    {leftArrow}
    {imageGroups.map(imageGroup => (
      <ImageRow key={JSON.stringify(imageGroup)} imageGroup={imageGroup} />
    ))}
    {rightArrow}
  </Grid>
);
